import { render, staticRenderFns } from "./Calculadora.vue?vue&type=template&id=5bdf27c7"
import script from "./Calculadora.vue?vue&type=script&lang=js"
export * from "./Calculadora.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports